import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthProvider';
import { useNavigate } from 'react-router-dom';

function ForgotPassword(props) {
    const [verificationCode, setVerificationCode] = useState('');
    const [password, setPassword] = useState('');
    const {setNewPassword} = useContext(AuthContext);
    const navigate = useNavigate();
  
    const handleSubmit = (e) => {
      e.preventDefault();
      // Handle registration logic, e.g., send data to API
      setNewPassword(verificationCode, password);
      navigate('/login');
    };
  
    return (
      <div className="App-body">
      <form onSubmit={handleSubmit}>
        New Password
        <div align="center">
        <input
          type="verificationCode"
          placeholder="Verification code from email"
          value={verificationCode}
          className="text-box-style"
          onChange={(e) => setVerificationCode(e.target.value)}
        /></div>
        <div align="center">
        <input
          type="password"
          placeholder="New Password"
          value={password}
          className="text-box-style"
          onChange={(e) => setPassword(e.target.value)}
        /></div>
        <div align="center">
        <button type="submit">Set New Password</button></div>
      </form></div>
    );
  }

  export default ForgotPassword;